import { mergeClasses } from "@fluentui/react-components";
import { useCustomToggleStyles } from "./CustomToggle.styles";
import { ICustomToggleProps } from "./CustomToggle.types";

export const CustomToggle = (props: ICustomToggleProps): JSX.Element => {
  const styles = useCustomToggleStyles();
  const {
    checked,
    onChange,
    label,
    hint,
    disabled = false,
    labelPosition = "start",
    isLabelBold = true,
  } = props;

  const handleClick = (): void => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (!disabled && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onChange(!checked);
    }
  };

  const toggle = (
    <div
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      className={mergeClasses(
        styles.track,
        checked && styles.trackChecked,
        disabled && styles.trackDisabled,
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <div
        className={mergeClasses(styles.thumb, checked && styles.thumbChecked)}
      />
    </div>
  );

  const labelContent = (
    <span
      className={mergeClasses(
        styles.toggleLabel,
        !isLabelBold && styles.toggleLabelRegular,
      )}
    >
      {label}
    </span>
  );

  return (
    <div className={styles.container}>
      <div className={labelPosition === "end" ? styles.rowEnd : styles.row}>
        {labelPosition === "end" ? (
          <>
            {labelContent}
            {toggle}
          </>
        ) : (
          <>
            {toggle}
            {labelContent}
          </>
        )}
      </div>
      {hint && <span className={styles.hint}>{hint}</span>}
    </div>
  );
};
